// Colores sólidos (HEX)
export const SolidColors = [
    '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000'
]

// Colores translúcidos (RGBA)
export const TransparentColors = [
    // 🔴 ROJOS
    { label: 'Rojo Vivo', value: 'rgba(255, 77, 79, 0.6)' },
    { label: 'Rojo Oscuro', value: 'rgba(178, 34, 34, 0.6)' },
    { label: 'Rojo Carmesí', value: 'rgba(220, 20, 60, 0.6)' },
    { label: 'Coral', value: 'rgba(255, 127, 80, 0.6)' },
    { label: 'Rojo Claro', value: 'rgba(255, 99, 71, 0.6)' },

    // 🟠 NARANJAS
    { label: 'Naranja', value: 'rgba(250, 140, 22, 0.6)' },
    { label: 'Naranja Intenso', value: 'rgba(255, 140, 0, 0.6)' },
    { label: 'Naranja Suave', value: 'rgba(255, 178, 102, 0.6)' },
    { label: 'Naranja Tierra', value: 'rgba(237, 145, 33, 0.6)' },

    // 🟡 AMARILLOS
    { label: 'Amarillo', value: 'rgba(250, 219, 20, 0.6)' },
    { label: 'Amarillo Claro', value: 'rgba(255, 255, 153, 0.6)' },
    { label: 'Amarillo Dorado', value: 'rgba(255, 219, 88, 0.6)' },
    { label: 'Oro Brillante', value: 'rgba(255, 215, 0, 0.6)' },

    // 🟢 VERDES
    { label: 'Verde Brillante', value: 'rgba(82, 196, 26, 0.6)' },
    { label: 'Verde Oscuro', value: 'rgba(0, 100, 0, 0.6)' },
    { label: 'Verde Lima', value: 'rgba(154, 205, 50, 0.6)' },
    { label: 'Verde Esmeralda', value: 'rgba(80, 200, 120, 0.6)' },
    { label: 'Verde Bosque', value: 'rgba(34, 139, 34, 0.6)' },
    { label: 'Verde Agua', value: 'rgba(0, 255, 128, 0.6)' },

    // 🔵 AZULES
    { label: 'Azul', value: 'rgba(24, 144, 255, 0.6)' },
    { label: 'Azul Marino', value: 'rgba(0, 0, 128, 0.6)' },
    { label: 'Azul Cielo', value: 'rgba(135, 206, 235, 0.6)' },
    { label: 'Azul Acero', value: 'rgba(70, 130, 180, 0.6)' },
    { label: 'Azul Eléctrico', value: 'rgba(30, 144, 255, 0.6)' },
    { label: 'Azul Real', value: 'rgba(65, 105, 225, 0.6)' },

    // 🟢🔵 TURQUESAS & CYAN
    { label: 'Turquesa', value: 'rgba(64, 224, 208, 0.6)' },
    { label: 'Aguamarina', value: 'rgba(127, 255, 212, 0.6)' },
    { label: 'Cyan', value: 'rgba(0, 255, 255, 0.6)' },
    { label: 'Verde Teal', value: 'rgba(0, 128, 128, 0.6)' },

    // 🟣 VIOLETAS & ROSAS
    { label: 'Morado', value: 'rgba(114, 46, 209, 0.6)' },
    { label: 'Violeta', value: 'rgba(148, 0, 211, 0.6)' },
    { label: 'Púrpura', value: 'rgba(128, 0, 128, 0.6)' },
    { label: 'Lavanda', value: 'rgba(230, 230, 250, 0.6)' },
    { label: 'Orquídea', value: 'rgba(218, 112, 214, 0.6)' },
    { label: 'Magenta', value: 'rgba(255, 0, 255, 0.6)' },
    { label: 'Rosa Intenso', value: 'rgba(255, 20, 147, 0.6)' },
    { label: 'Rosa Claro', value: 'rgba(255, 182, 193, 0.6)' },

    // ⚪ NEUTROS
    { label: 'Gris Claro', value: 'rgba(211, 211, 211, 0.6)' },
    { label: 'Gris Medio', value: 'rgba(169, 169, 169, 0.6)' },
    { label: 'Gris Oscuro', value: 'rgba(89, 89, 89, 0.6)' },

    // 🌈 EXTRA – TONOS ESPECIALES
    { label: 'Marrón', value: 'rgba(139, 69, 19, 0.6)' },
    { label: 'Café Oscuro', value: 'rgba(101, 67, 33, 0.6)' },
    { label: 'Beige', value: 'rgba(245, 245, 220, 0.6)' },
    { label: 'Verde Oliva', value: 'rgba(128, 128, 0, 0.6)' },
    { label: 'Caqui Claro', value: 'rgba(240, 230, 140, 0.6)' },
    { label: 'Plata', value: 'rgba(192, 192, 192, 0.6)' },
    { label: 'Oro Viejo', value: 'rgba(184, 134, 11, 0.6)' },
    { label: 'Cobre', value: 'rgba(205, 127, 50, 0.6)' }
]